import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { getHtml } from '../../../helper';

// Gated checkbox: checking it opens the camp's agreement text in a modal and only sets the
// answer to true once the applicant clicks "I agree" inside it — unchecking is immediate.
const AgreementCheckboxField = ({ label, value, onChange, agreementText, required }) => {
    const [modalOpen, setModalOpen] = useState(false);

    const handleChange = () => {
        if (value) {
            onChange(false);
        } else {
            setModalOpen(true);
        }
    };

    return (
        <>
            <label className="tw-flex tw-cursor-pointer tw-items-start tw-gap-3">
                <input
                    type="checkbox"
                    checked={Boolean(value)}
                    onChange={handleChange}
                    className="tw-mt-0.5 tw-h-4 tw-w-4 tw-shrink-0 tw-rounded tw-border-sand-300 tw-text-brand-600 focus:tw-ring-brand-500" />
                <span className="tw-text-sm tw-leading-relaxed tw-text-gray-700">
                    {label}
                    {required ? <span className="tw-ml-1 tw-text-brand-600">*</span> : null}
                </span>
            </label>

            <Modal dialogClassName="h_auto" show={modalOpen} size="lg" animation={false} centered>
                <Modal.Body>
                    <span className="modal_close">
                        <span onClick={() => setModalOpen(false)}><i className="icon-cross" /></span>
                    </span>
                    <div className="p-5">
                        <h3 className="text-center mb-4">Agreement</h3>
                        <p>{agreementText ? getHtml(agreementText) : ''}</p>
                        <span className="btn btn-primary w-100 mt-2" onClick={() => { setModalOpen(false); onChange(true); }}>I agree</span>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AgreementCheckboxField;
